import { languages } from "./skills";
import abaru1 from "./assets/abaru1.png";
import abaru2 from "./assets/abaru2.png";
import abaru3 from "./assets/abaru3.png";
import playground1 from "./assets/playground1.jpg";
import playground2 from "./assets/playground2.jpg";
import playground3 from "./assets/playground3.jpg";
// import hanchor1 from "./assets/hanchor1.jpg";
// import hanchor2 from "./assets/hanchor2.jpg";
// import hanchor3 from "./assets/hanchor3.jpg";
import portfolio1 from "./assets/portfolio1.png";
import portfolio2 from "./assets/portfolio2.png";
import portfolio3 from "./assets/portfolio3.png";
import sterling1 from "./assets/sterling1.jpg";
import sterling2 from "./assets/sterling2.jpg";
import sterling3 from "./assets/sterling3.jpg";
import elx1 from "./assets/elx1.jpg";
import elx2 from "./assets/elx2.jpg";
import elx3 from "./assets/elx3.jpg";
import augnect1 from "./assets/01.jpeg";
import augnect2 from "./assets/02.jpeg";
import augnect3 from "./assets/03.jpeg";
import augnect4 from "./assets/04.jpeg";
import augnect5 from "./assets/05.jpeg";
import app1 from "./assets/APP1.jpg";
import app2 from "./assets/APP2.jpg";
import app3 from "./assets/APP3.jpg";
import gb1 from "./assets/GB1.png";
import gb2 from "./assets/GB2.jpg";
import gb3 from "./assets/GB3.jpg";
import gb4 from "./assets/GB4.jpg";
import chat from "./assets/Chat.png";

export const github = "https://github.com/Osebest";
export const linkedIn = "https://www.linkedin.com/in/ephraim-udazi/";
export const twitter = "https://twitter.com/Osebest7";
export const mail = "mailto:udazi.osebest@gmail.com";

let skillUsed = languages().props.children;
export const allProjects = [
  {
    id: 1,
    title: "AI Chat App",
    role: "AI Engineer",
    year: "2026",
    short: "An AI-powered chat companion application.",
    description:
      "An AI-powered chat application that provides users with a personalized and interactive chat companion experience. The app utilizes advanced natural language processing and machine learning algorithms to understand user input and generate relevant and engaging responses. It offers a seamless and intuitive interface, allowing users to have meaningful conversations with the AI chat companion on various topics, providing entertainment, information, and companionship.",
    skills: [skillUsed[1], skillUsed[8], skillUsed[10]],
    images: [chat, chat],
    links: ["", ""],
  },
  {
    id: 1,
    title: "Augnect",
    role: "Mobile Engineer",
    year: "2024",
    short: "An augmented reality knowledge platform for B2B companies.",
    description:
      "An augmented reality knowledge platform for B2B companies. Augnect is in the business of making the intangible, tangible! Through their state of the art technology, they are in the journey of taking the world on by a storm and this next generation of innovation requires an intuitive AR mobile application",
    skills: [skillUsed[1], skillUsed[8], skillUsed[10]],
    images: [augnect1, augnect2, augnect3, augnect4, augnect5],
    links: ["", "https://apps.apple.com/ng/app/augnect/id1600698150"],
  },
  {
    id: 2,
    title: "Grüne Brise",
    role: "FrontEnd Dev",
    year: "2023",
    short: "Grüne Brise allows easy access to medicinal cannabis",
    description:
      "Grüne Brise allows easy access to medicinal cannabis and makes it as convenient as possible for all patients across the board and in compliance with the legal provisions.",
    skills: [skillUsed[1], skillUsed[8], skillUsed[10]],
    images: [gb1, gb2, gb3, gb4],
    links: ["", "https://shop.gruenebrise.de/"],
  },
  {
    id: 3,
    title: "Abaru.IO",
    role: "FrontEnd Dev",
    year: "2022",
    short: "An E-commerce company's website",
    description:
      "A landing page to an E-commerce company that provides trustworthy platform for scalable delivery services",
    skills: [skillUsed[0], skillUsed[1], skillUsed[2], skillUsed[6]],
    images: [abaru1, abaru2, abaru3],
    links: [
      "https://github.com/Abaru-io/landingpage-test",
      "https://abaru-landing-page.netlify.app/",
    ],
  },
  // {
  //   id: 3,
  //   title: "Hanchor App",
  //   role: "FrontEnd Dev",
  //   year: "2022",
  //   short: "An inspirational app available on all platforms",
  //   description:
  //     "Hanchor is inpiring life. An app available on all platforms to insire you everyday,connect you with your future through goal setting and lots more",
  //   skills: [skillUsed[1], skillUsed[8], skillUsed[10]],
  //   images: [hanchor1, hanchor2, hanchor3],
  //   links: [
  //     "https://github.com/NGDevs/Hanchor_Web",
  //     "https://hanchor-web.netlify.app/",
  //   ],
  // },
  {
    id: 4,
    title: "Sterling",
    role: "FrontEnd Dev",
    year: "2020",
    short: "A kitchen for all, where the big boys chill",
    description:
      "Welcome page to the Chop Laif geng… A place where all the glazed, fried and tasty do usually occur!",
    skills: [skillUsed[0], skillUsed[2], skillUsed[6], skillUsed[1]],
    images: [sterling1, sterling2, sterling3],
    links: [
      "https://github.com/Osebest/GSAP-Animation-",
      "https://sterling-choplaif.netlify.app/",
    ],
  },
  // {
  //   id: 5,
  //   title: "Osebest.com",
  //   role: "Web Dev",
  //   year: "2022",
  //   short: "My personal portfolio website",
  //   description: "This is my work of Art, my PortFolio",
  //   skills: [
  //     skillUsed[0],
  //     skillUsed[1],
  //     skillUsed[2],
  //     skillUsed[6],
  //     skillUsed[5],
  //   ],
  //   images: [portfolio1, portfolio2, portfolio3],
  //   links: ["https://github.com/Osebest/MyPortfolio", ""],
  // },
  {
    id: 5,
    title: "APP",
    role: "Web Dev",
    year: "2023",
    short: "APP is a game-changing platform",
    description:
      "APP is a game-changing platform that simplifies car preparation for both large dealerships and individual customers. The platform caters to three key user groups: customers, team partners, and APP staff.",
    skills: [
      skillUsed[0],
      skillUsed[1],
      skillUsed[2],
      skillUsed[6],
      skillUsed[5],
    ],
    images: [app1, app2, app3],
    links: ["", "https://app-aid.de/"],
  },
  {
    id: 6,
    title: "My Portfolio",
    role: "Web Dev",
    year: "2022",
    short: "My personal portfolio website",
    description: "This is my work of Art, my PortFolio",
    skills: [
      skillUsed[0],
      skillUsed[1],
      skillUsed[2],
      skillUsed[6],
      skillUsed[5],
    ],
    images: [portfolio1, portfolio2, portfolio3],
    links: ["https://github.com/Osebest/MyPortfolio", ""],
  },
  {
    id: 7,
    title: "ElxCall App",
    role: "FrontEnd Dev",
    year: "2021",
    short: "An app for all celebrities, connecting them with their fans",
    description:
      "A landing page for an app that links celebrities to their fans",
    skills: [skillUsed[0], skillUsed[1], skillUsed[2], skillUsed[6]],
    images: [elx1, elx2, elx3],
    links: [
      "https://github.com/Osebest/Elxcall-Replica-Animated-",
      "https://osebest.github.io/Elxcall-Replica-Animated-/",
    ],
  },
  {
    id: 8,
    title: "PlayGround",
    role: "Web Dev",
    year: "2021",
    short: "A place where I show off what I can do",
    description: "Yeah, you read it right, it's just a unique playground",
    skills: [skillUsed[0], skillUsed[1], skillUsed[2], skillUsed[8]],
    images: [playground1, playground2, playground3],
    links: [
      "https://github.com/Osebest/My-place",
      "https://osebest-place.netlify.app/",
    ],
  },
];
